<template lang="pug">
  div(:class="this.payload.fields.name.toLowerCase()+' section-container clearfix container-'+this._uid")
    ul.collection
      li.item(v-for="(d, i) in this.collectionItems" :class="d.raw.fields.active === false && 'inactive'")
        a.directLink(v-if="d.url" :href="d.url")
          div.itemImage
            img(:src="d.image.url" :alt="d.image.fileName")
          div.itemContent
            h4.title
              vue-markdown(:source='d.title')
            vue-markdown(:source='d.desc' class="desc")
        router-link(v-if="!d.url" :to="{ path: d.slug ? '/' + d.slug : '/' + d.type + '/' + d.id}" :key="'collection-item-' + i")
          div.itemImage
            img(:src="d.image.url" :alt="d.image.fileName")
          div.itemContent
            h4.title
              vue-markdown(:source='d.title')
            vue-markdown(:source='d.desc' class="desc")
    //- router-link.section-link.button.minimal(v-show="this.link" :to="{ path: this.link }") {{ 'view all ' + this.payload.fields.name && this.payload.fields.name.toLowerCase() }}
</template>

<script>
import Vue from 'vue'
import sectionBase from '@/components/sections/sectionBase.js'

// TODO: create parseCollection function for normalizing collection data (to account for it not actually being a collection but just a raw list of entries) for all template components like this one and contentSlider etc

// component instance
var collectionList = Vue.component('collection-list', {
  name: 'collectionList',
  mixins: [sectionBase],
  props: [],
  data: function () {
    return {
    }
  },
  watch: {
  },
  methods: {
  },
  computed: {
    collectionItems () {
      // @products - TODO: product routes should be created per (retrieved) type
      let items = []
      this.payload.fields.content.forEach((d) => {
        if (d.fields.itemReferences) {
          d.fields.itemReferences.forEach((n) => {
            items.push({title: n.fields.title, desc: n.fields.description || n.fields.body, url: n.fields.url, slug: n.fields.slug, image: n.fields.image.fields.file, type: n.fields.type && n.fields.type.toLowerCase(), category: n.fields.category, price: n.fields.price, id: n.sys.id, raw: n})
          })
        } else {
          items.push({title: d.fields.title, desc: d.fields.description || d.fields.body, url: d.fields.url, slug: d.fields.slug, type: d.fields.type && d.fields.type.toLowerCase(), category: d.fields.category, price: d.fields.price, id: d.sys.id, raw: d})
        }
      })
      return items
    }
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default collectionList
</script>

<style scoped lang="scss">
.section-container{
  display: block;
  margin-top: 3rem;
}

.collection{
  list-style: none;

  .item{
    &.inactive{
      border-color: $medium-gray !important;
    }
  }

  .item{
    display: block;
    width: 50%;

    border-radius: $global-radius;
    padding: 2rem;

    > a{ display: inline-block; }

    .itemImage{
      float: left;
      margin: measure(xxs);
      min-height: measure(sm) + measure(xs);
    }
    .itemContent{
      float: left;
      padding-left: measure(xxs);
      // flex-wrap: nowrap;
    }

    .title{
    }
    .desc{
      color: $black;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/sections/collectionList.vue